export default __webpack_public_path__ + "locales/ja-JP/OAuth.json?hash=65c7793c0a75995ad3f98f93d1a4b248";